export const TABLE_COLUMNS = {
  SELECT: "select",
  ID: "id",
  TIME: "time",
  ORDER_SOURCE: "order_source",
  ANNOTATOR_ID: "annotator_id",
  STATUS: "status",
  ANOMALY_REPORT: "anomaly_report",
} as const;

export interface BaseCellProps {
  value?: string;
  onDetailsClick?: () => void;
}

export const STAGE_STATUS = {
  NOT_STARTED: "not_started",
  DONE: "done",
  REJECTED: "rejected",
} as const;

export const ORDER_STATUS = {
  NOT_STARTED: "not_started",
  FINISHED: "finished",
  ARCHIVED: "archived",
  PENDING: "pending",
} as const;

export const ORDER_SOURCE = {
  SKU_IN_BOX: "sku-in-box",
  MOBILE_APP_HITL: "mobile-app-hitl",
  COFFEE_MACHINE: "coffee_machine",
  TEMPORARY_ORDER: "temporary-order",
  TRACKER_TEST_SETUP: "tracker-test-setup",
  ANONYMOUS_JOURNEY_RECORDINGS: "anonymous-journey-recordings",
  JOURNEY_RECORDINGS: "journey-recordings",
} as const;

export const REJECTION_REASON = {
  OTHER: "other",
} as const;

export const BADGE_COLOR = {
  GRAY: "gray",
  GREEN: "green",
  RED: "red",
} as const;

export const ANNOTATION_STATUS = {
  DONE: "done",
  REJECTED: "rejected",
  ANOMALY: "anomaly",
  NOT_STARTED: "not_started",
} as const;

export const STAGE_STATUS_TEXT = {
  [STAGE_STATUS.NOT_STARTED]: "Not Started",
  [STAGE_STATUS.DONE]: "Done",
  [STAGE_STATUS.REJECTED]: "Rejected",
} as const;

export type AnnotationStatusType =
  (typeof ANNOTATION_STATUS)[keyof typeof ANNOTATION_STATUS];
export type StageStatus = (typeof STAGE_STATUS)[keyof typeof STAGE_STATUS];
export type OrderStatus = (typeof ORDER_STATUS)[keyof typeof ORDER_STATUS];
export type OrderSource = (typeof ORDER_SOURCE)[keyof typeof ORDER_SOURCE];
export type RejectionReason =
  (typeof REJECTION_REASON)[keyof typeof REJECTION_REASON];
export type TableColumn = (typeof TABLE_COLUMNS)[keyof typeof TABLE_COLUMNS];
export type BadgeColor = (typeof BADGE_COLOR)[keyof typeof BADGE_COLOR];

export interface FilterParams {
  [key: string]: string | undefined;
  search?: string;
  order_source?: string;
  annotator_id?: string;
  from_datetime?: string;
  to_datetime?: string;
  ordering?: string;
  stage_name?: string;
  stage_status?: string;
}
